<div class="container">
    <h1
        [innerHTML]="'conditions-utilisation.titre' | translate"></h1>

    <div class="navigation">
        <h2 [innerHTML]="'conditions-utilisation.toc' | translate"></h2>
        <nav>
            <ul>
                <li>
                    <a href="/conditions-utilisation#section-cartographie-planification-developpement-territoire-public"
                        [innerHTML]="'conditions-utilisation.cartographie-planification-developpement-territoire-public.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-acceptation-conditions-utilisation"
                        [innerHTML]="'conditions-utilisation.acceptation-conditions-utilisation.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-protection-renseignements-personnels-securite"
                        [innerHTML]="'conditions-utilisation.protection-renseignements-personnels-securite.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-propriete-intellectuelle"
                        [innerHTML]="'conditions-utilisation.propriete-intellectuelle.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-utilisation-carte-interactive"
                        [innerHTML]="'conditions-utilisation.utilisation-carte-interactive.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-exactitude-information"
                        [innerHTML]="'conditions-utilisation.exactitude-information.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-disponibilite-service"
                        [innerHTML]="'conditions-utilisation.disponibilite-service.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-liens-autres-sites-internet"
                        [innerHTML]="'conditions-utilisation.liens-autres-sites-internet.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-exclusion-responsabilite"
                        [innerHTML]="'conditions-utilisation.exclusion-responsabilite.titre' | translate"></a>
                </li>
                <li>
                    <a href="/conditions-utilisation#section-contact"
                        [innerHTML]="'conditions-utilisation.contact.titre' | translate"></a>
                </li>
            </ul>
        </nav>
    </div>

    <div class="sections">
        <div id="section-cartographie-planification-developpement-territoire-public">
            <h2
                [innerHTML]="'conditions-utilisation.cartographie-planification-developpement-territoire-public.titre' | translate">
            </h2>
            <div
                [innerHTML]="'conditions-utilisation.cartographie-planification-developpement-territoire-public.texte' | translate">
            </div>
        </div>

        <div id="section-acceptation-conditions-utilisation">
            <h2 [innerHTML]="'conditions-utilisation.acceptation-conditions-utilisation.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.acceptation-conditions-utilisation.texte' | translate">
            </div>
        </div>

        <div id="section-protection-renseignements-personnels-securite">
            <h2 [innerHTML]="'conditions-utilisation.protection-renseignements-personnels-securite.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.protection-renseignements-personnels-securite.texte' | translate">
            </div>
        </div>

        <div id="section-propriete-intellectuelle">
            <h2 [innerHTML]="'conditions-utilisation.propriete-intellectuelle.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.propriete-intellectuelle.texte' | translate">
            </div>
        </div>

        <div id="section-utilisation-carte-interactive">
            <h2 [innerHTML]="'conditions-utilisation.utilisation-carte-interactive.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.utilisation-carte-interactive.texte' | translate">
            </div>
        </div>

        <div id="section-exactitude-information">
            <h2 [innerHTML]="'conditions-utilisation.exactitude-information.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.exactitude-information.texte' | translate">
            </div>
        </div>

        <div id="section-disponibilite-service">
            <h2 [innerHTML]="'conditions-utilisation.disponibilite-service.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.disponibilite-service.texte' | translate">
            </div>
        </div>

        <div id="section-liens-autres-sites-internet">
            <h2 [innerHTML]="'conditions-utilisation.liens-autres-sites-internet.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.liens-autres-sites-internet.texte' | translate">
            </div>
        </div>

        <div id="section-exclusion-responsabilite">
            <h2 [innerHTML]="'conditions-utilisation.exclusion-responsabilite.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.exclusion-responsabilite.texte' | translate">
            </div>
        </div>

        <div id="section-contact">
            <h2 [innerHTML]="'conditions-utilisation.contact.titre' | translate">
            </h2>
            <div [innerHTML]="'conditions-utilisation.contact.texte' | translate">
            </div>
        </div>

    </div>

</div>